import React from 'react';
import { Tooltip } from '@folksam/ui-next/components/organisms/Tooltip';
import { FormField as UIFormField } from '@folksam/ui-next/components';

export default function FormField({ label, labelExample, id, meta, tooltipText, component, inputProps, ...props }) {
    return (
        <>
            <UIFormField
                sx={{
                    textAlign: 'initial',
                    '> * > * > * > div': {
                        zIndex: 1,
                        minWidth: '200px'
                    }
                }}
                component={component}
                inputProps={{
                    required: meta.touched && meta.error ? true : false,
                    invalid: meta.touched && meta.error ? true : false,
                    postfix: tooltipText ? <Tooltip>{tooltipText}</Tooltip> : null,
                    ...inputProps,
                    id: label
                }}
                {...props}
                label={label}
                labelExample={labelExample}
                error={meta.error}
            />
        </>
    );
}
